import axios, { AxiosStatic } from 'axios';
import Secret from '@/core/Secret';
import { secret, resHandler } from '@/core/utils';
import { URL } from '@/axios/URL';

//上传文件
export const noSign = axios.create({
	baseURL: URL.BASE_URL,
	// headers: { 'Content-Type': 'multipart/form-data' }
});

// export const uploadFile = function ( file:any , returnType?:string ){
//     return Cos.putFile( file , returnType )
// }


noSign.interceptors.request.use((config) => {
	// 加密
	console.log( config , '发送前拦截')
	return config;
},  resHandler.netConnectionFail);

// 拦截响应解密
noSign.interceptors.response.use((res) => {
	let resData = res.data;

	return resData;
},  resHandler.netConnectionFail);

declare module "vue/types/vue" {
	interface Vue {
		$noSign: any
	}
}